import apiClient from "../../client/apiClient"
import { appendQueryParams } from "../../utils"
import { Class } from "../classes"
import { FEE_GROUP } from "../fee-group"

const FEE_TYPE_ENDPOINT = {
  CREATE_FEE_TYPE: "/fee-type",
  UPDATE_FEE_TYPE: "/fee-type",
  DELETE_FEE_TYPE: "/fee-type",
  GET_ALL_FEE_TYPE: "/fee-type",
}

export type FeeRecord = {
  _id: string
  name: string
  amount: number
  status: string
  isDeleted: boolean
  deletedBy: string | null
  session: string
  system: string
  createdAt: string
  updatedAt: string
  feeGroup: FEE_GROUP
  classes: Class[]
  dueAfterDays: number
  frequency: string
  examinationFeeDate: string
  applicableFrom: string 
}

const createFeeType = async (data: {
  name: string
  classes: string[]
  amount: number
  feeGroup: string
  status: string
  system: string
  session: string
  dueAfterDays: number
  frequency: string
  applicableFrom?: string 
  examinationFeeDate?: string 
}) => {
  const response = await apiClient({
    url: FEE_TYPE_ENDPOINT.CREATE_FEE_TYPE,
    method: "POST",
    data,
  })
  return response.data
}

// Clone all fee types from one session into another (same campus), optionally
// bumping amounts by a percentage. Skips fee types already present in target.
const copyFeeTypes = async (data: {
  fromSession: string
  toSession: string
  increasePercent?: number
}) => {
  const response = await apiClient({
    url: `${FEE_TYPE_ENDPOINT.CREATE_FEE_TYPE}/copy`,
    method: "POST",
    data,
  })
  return response.data
}

const updateFeeType = async (
  id: string,
  data: {
    name?: string
    classes?: string[]
    amount?: number
    feeGroup?: string
    status?: string
    system?: string
    session?: string
    dueAfterDays?: number
    frequency?: string
    applicableFrom?: string
    examinationFeeDate?: string 
  }
) => {
  const response = await apiClient({
    url: `${FEE_TYPE_ENDPOINT.UPDATE_FEE_TYPE}/${id}`,
    method: "PUT",
    data,
  })
  return response.data
}

const deleteFeeType = async (id: string) => {
  const response = await apiClient({
    url: `${FEE_TYPE_ENDPOINT.DELETE_FEE_TYPE}/${id}`,
    method: "DELETE",
  })
  return response.data
}

const getAllFeeType = async ({
  page = 1,
  limit = 10,
  searchText,
  classes,
  session,
  system,
  name,
  sortBy,
  sortOrder,
  status,
  feeGroup,
}: {
  page?: number
  limit?: number
  searchText?: string
  classes?: string
  session?: string
  system?: string
  name?: string
  sortBy?: string
  sortOrder?: string
  status?: string
  feeGroup?: string
}): Promise<{ pagination: any; data: FeeRecord[] }> => {
  const response = await apiClient({
    url: appendQueryParams(FEE_TYPE_ENDPOINT.GET_ALL_FEE_TYPE, {
      page,
      limit,
      searchText,
      classes,
      session,
      system,
      name,
      sortBy,
      sortOrder,
      status,
      feeGroup
    }),
    method: "GET",
  })
  return response.data
}

const getFeeTypeById = async (id: string): Promise<{ data: FeeRecord }> => {
  const response = await apiClient({
    url: `${FEE_TYPE_ENDPOINT.GET_ALL_FEE_TYPE}/${id}`,
    method: "GET",
  })
  return response.data
}

export {
  createFeeType,
  copyFeeTypes,
  updateFeeType,
  deleteFeeType,
  getAllFeeType,
  getFeeTypeById
}